<template>
  <div class="navigation">
    <div class="navigation__logo">
      <logo class="logo" />
    </div>
    <div>
      <router-link
        v-for="(item, index) in items"
        :key="`m-${index}`"
        :to="item.to"
        tag="div"
        exact-active-class="is-active"
        class="navigation__option"
        :class="{
          'has-badge': item.hasBadge && messageFromHistory,
        }"
        role="button"
        @click.native="openTab(item)"
      >
        <component
          v-tooltip="getName(index)"
          :is="index === 0 ? chatIcon : chatHistoryIcon"
          class="navigation__option-icon"
        />
        <hcc-badge
          v-if="totalUnreadMessages > 0 && item.hasBadge"
          :text="unreadMessages"
          size="xs"
          color="alert"
          fill
          rounded
          customClass="navigation__badge"
        />
      </router-link>
    </div>
    <div class="navigation__filler"></div>
    <theme-button :theme="theme" />
    <div class="navigation__lang">
      <language-button />
    </div>
    <user-status />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Logo from '@/assets/images/logos/sellia-icon-color.svg';
import MenuChatIcon from '@/assets/icons/menu-chat.svg';
import MenuChatDarkIcon from '@/assets/icons/menu-chat-dark.svg';
import MenuHistoryIcon from '@/assets/icons/menu-history-light.svg';
import MenuHistoryDarkIcon from '@/assets/icons/menu-history-dark.svg';
import MenuSettingsIcon from '@/assets/icons/menu-settings.svg';
import UserStatus from '@/components/UserStatus.vue';
import LanguageButton from '@/components/LanguageButton.vue';
import ThemeButton from '@/components/ThemeButton.vue';
import HccBadge from '@/components/shared/HccBadge/index.vue';

export default {
  components: {
    Logo,
    MenuChatIcon,
    MenuChatDarkIcon,
    MenuHistoryIcon,
    MenuHistoryDarkIcon,
    MenuSettingsIcon,
    UserStatus,
    LanguageButton,
    ThemeButton,
    HccBadge,
  },
  data() {
    return {
      items: [
        {
          to: '/',
          hasBadge: true,
        },
        {
          to: '/history',
          hasBadge: false,
        },
        /* {
          to: '/settings',
          icon: 'menu-settings-ico',
          hasBadge: false,
        }, */
      ],
    };
  },
  computed: {
    ...mapGetters([
      'totalUnreadMessages',
      'hasUnreadMessages',
      'theme',
      'messageFromHistory',
    ]),
    light() {
      return this.theme === 'light';
    },
    chatIcon() {
      return this.light ? 'menu-chat-icon' : 'menu-chat-dark-icon';
    },
    chatHistoryIcon() {
      return this.light ? 'menu-history-icon' : 'menu-history-dark-icon';
    },
    unreadMessages() {
      return this.totalUnreadMessages > 99 ? '+99' : this.totalUnreadMessages;
    },
  },
  methods: {
    ...mapMutations([
      'setMessageFromHistory',
    ]),
    openTab(tab) {
      if (tab.hasBadge) {
        this.setMessageFromHistory(false);
      }
    },
    showMessagesBadge(tab) {
      return this.hasUnreadMessages && tab.hasBadge && !this.messageFromHistory;
    },
    getName(index) {
      return index === 0 ? this.$t('chat.tab-conversations') : this.$t('chat.tab-history');
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 35px;
  width: 35px;
}
</style>
